import styled from 'styled-components';
import { Type, TextLink } from '@spotify-internal/encore-creator-web';
import {
  gray10,
  gray45,
  gray90,
  gray95,
  spacer12,
  spacer16,
} from '@spotify-internal/encore-foundation';
import { CoverArt } from '../../../shared/components/CoverArt';

export const StatsRowContainer = styled.div`
  border-bottom: 1px solid ${gray90};
  min-width: 0;

  ${({ isDisabled }) =>
    isDisabled
      ? `opacity: 0.5`
      : `&:hover {
      background-color: ${gray95};
      cursor: pointer;
    }`}
`;

export const CenteredFlexDiv = styled.div`
  align-items: center;
  display: flex;
`;

export const StatsRow = styled(CenteredFlexDiv)`
  justify-content: space-between;
  min-width: 0;
  padding-bottom: ${spacer12};
  padding-top: ${spacer12};
`;

export const StatsMediaEntity = styled(CenteredFlexDiv)`
  min-width: 0;
`;

export const StatsDeltaContainer = styled(CenteredFlexDiv)`
  flex-direction: row;
  justify-content: flex-end;
  margin-left: ${spacer12};
`;

export const StatsDeltaTitle = styled(Type.p).attrs({
  variant: Type.body2,
  weight: Type.book,
  condensed: true,
  color: gray45,
})`
  font-feature-settings: 'tnum';
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const StatsMediaInfo = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: ${spacer12};
  min-width: 0;
`;

export const StatsMediaTitle = styled(Type.p).attrs({
  variant: Type.body2,
  weight: Type.bold,
  condensed: true,
})`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const StatsEmptyText = styled(Type.p).attrs({
  variant: Type.body2,
  color: gray10,
})`
  margin-top: ${spacer16};
`;

export const StatsMediaCover = styled(CoverArt)`
  flex-shrink: 0;
`;

export const StatsTextLink = styled(TextLink)`
  &&& {
    display: initial; /*  ensures text ellipsis when overflow */
    text-decoration: none;

    &:hover {
      color: inherit;
      text-decoration: none;
    }
    /* apply encore web inspired focus state */
    &:focus {
      outline: none;
      box-shadow: 0 3px 0 0 ${gray10};
      transition: box-shadow 200ms ease-in;
    }
  }
`;
